import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FilterLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M5 12V4M19 20v-3M5 20v-4M19 13V4M12 7V4M12 20v-9" }),
            React.createElement("circle", { cx: 5, cy: 14, r: 2, stroke: "currentColor", strokeLinecap: "round" }),
            React.createElement("circle", { cx: 12, cy: 9, r: 2, stroke: "currentColor", strokeLinecap: "round" }),
            React.createElement("circle", { cx: 19, cy: 15, r: 2, stroke: "currentColor", strokeLinecap: "round" })));
}
const FilterLight = forwardRef(_FilterLight);
export { FilterLight };
